module.exports = __webpack_public_path__ + "img/1.f5d6f8ff.jpg";